module.exports = __webpack_public_path__ + "assets/site-logo.8842f198.png";


//////////////////
// WEBPACK FOOTER
// ../source/assets/site-logo.png
// module id = 1162
// module chunks = 26